import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions';
import { useAppContext } from '../AppContext';

const AiReplyGenerator = ({ content, onReplyGenerated }) => {
    const { t } = useTranslation();
    const { appFunctions, setMessage, LucideIcons, user } = useAppContext(); // Add user
    const [isLoading, setIsLoading] = useState(false);

    const handleGenerateReply = async () => {
        if (!user) {
            setMessage(t('aiReplyGenerator.signInRequired'));
            return;
        }

        setIsLoading(true);
        setMessage(t('aiReplyGenerator.generating'));

        try {
            const func = httpsCallable(appFunctions, 'generateAiReply');
            const result = await func({ content });
            onReplyGenerated(result.data.reply);
        } catch (error) {
            setMessage(t('aiReplyGenerator.error', { error: error.message }));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <button onClick={handleGenerateReply} className="ai-icon-button text-green-400 hover:bg-green-400/20" disabled={isLoading}>
            {isLoading ? <div className="action-spinner" /> : <LucideIcons.Bot size={16} />}
        </button>
    );
};

export default AiReplyGenerator;
